import React from 'react';

export const RedXLogo = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.8233 20.4886C25.5115 15.8005 25.5115 8.19951 20.8233 3.51137C16.1352 -1.17677 8.53419 -1.17677 3.84605 3.51137C-0.842089 8.19951 -0.842089 15.8005 3.84605 20.4886C8.53419 25.1768 16.1352 25.1768 20.8233 20.4886Z"
        fill="#FF1F1F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.3897 15.2131L15.5471 11.0557L18.8353 7.76748C19.1354 7.4664 19.3038 7.05867 19.3038 6.63362C19.3038 6.20857 19.1354 5.80084 18.8353 5.49976C18.5342 5.19972 18.1265 5.03125 17.7015 5.03125C17.2764 5.03125 16.8687 5.19972 16.5676 5.49976L13.2889 8.78795L9.12193 12.9454L5.83375 16.2336C5.53371 16.5347 5.36523 16.9424 5.36523 17.3675C5.36523 17.7925 5.53371 18.2003 5.83375 18.5013C6.13482 18.8014 6.54255 18.9698 6.9676 18.9698C7.39266 18.9698 7.80038 18.8014 8.10146 18.5013L11.3897 15.2131Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.5468 12.9454L11.3893 8.78795L8.0917 5.49976C7.79062 5.19972 7.38289 5.03125 6.95784 5.03125C6.53278 5.03125 6.12506 5.19972 5.82398 5.49976C5.52394 5.80084 5.35547 6.20857 5.35547 6.63362C5.35547 7.05867 5.52394 7.4664 5.82398 7.76748L9.11217 11.0462L13.2696 15.2131L16.5578 18.5013C16.8589 18.8014 17.2666 18.9698 17.6917 18.9698C18.1168 18.9698 18.5245 18.8014 18.8256 18.5013C19.1256 18.2003 19.2941 17.7925 19.2941 17.3675C19.2941 16.9424 19.1256 16.5347 18.8256 16.2336L15.5468 12.9454Z"
        fill="white"
      />
    </svg>
  );
};
